export default {
  id: 'swing-vs-intraday',
  title: 'Swing vs Intraday',
  content: `## Swing vs Intraday Scenarios

ACT offers two types of scenarios. They test different skills and suit different trading styles. Every day there are 10 of each.

---

## Swing Scenarios

Swing scenarios are based on **daily candles** from NSE stocks. They test your ability to identify multi-day trading opportunities.

| Property | Value |
|---|---|
| Candle timeframe | Daily OHLCV |
| Signal source | Daily technical indicators (RSI, MACD, BB, 52W levels, volume) |
| Outcome window | 15 trading days after the signal |
| Target | +8% from entry |
| Stop loss | −4% from entry |
| Default R:R | 2:1 |

**What you are practising:** Reading a daily chart, identifying trend direction, assessing whether a breakout or reversal signal has enough supporting context to enter.

**After submitting:** The 15-day outcome candles are revealed, showing whether price hit the +8% target, the −4% stop, or neither within the window.

---

## Intraday Scenarios

Intraday scenarios are based on **1-minute candles** from the same NSE stocks. They test your ability to read fast-moving intraday setups.

| Property | Value |
|---|---|
| Candle timeframe | 1-minute OHLCV |
| Signal source | Intraday patterns (ORB, VWAP, momentum, gap, squeeze) |
| Outcome window | Rest of the same trading session |
| Target | +2% from entry |
| Stop loss | −1% from entry |
| Default R:R | 2:1 |

**What you are practising:** Reading intraday price structure, identifying momentum shifts, understanding where VWAP and the opening range play a role.

**After submitting:** The remaining session candles are revealed, showing whether the intraday move played out.

---

## Key Differences

| Dimension | Swing | Intraday |
|---|---|---|
| Time horizon | Days to weeks | Minutes to hours |
| Signal quality | Fewer signals, higher base quality | More signals, faster moving |
| Stop tightness | Wider stops relative to entry | Tighter stops |
| Chart reading speed | Slower, analytical | Fast, pattern recognition |
| Emotional demand | Patience-heavy | Reaction-speed heavy |

---

## Which Should You Start With?

**Start with Swing** if you are new to trading or ACT. Daily charts move slower, signals are clearer, and you have more time to think through the setup.

Once your Swing scenario scores are consistently above 75, add Intraday scenarios to train pattern recognition speed.

---

## Scoring Is the Same

Both types use the same four-dimension scoring system: Setup Quality, Entry Quality, Risk Management, and Decision Quality. The weight of each dimension does not change between types.`,
};
